import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserService } from "../Services/user.service";
import { AppConfig } from '../app.config';
import {environment} from '../../environments/environment';
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  providers: [UserService]
})
export class ResetPasswordComponent implements OnInit {
 //navToUrl: string = AppConfig.settings.apiServer.portalUrl;
  userId: string;
  code: string;
  email: string;
  newPassword: string;
  confirmPassword: string;
  private sub: any;
  passwordChanged: boolean;
  showErrorMsg: boolean;
  portalUrl: string = environment.main_url;
  //portalUrl: string = AppConfig.settings.apiServer.portalUrl;

  constructor(private userService: UserService, private route: ActivatedRoute) {
    this.passwordChanged = false;
    this.showErrorMsg = false;
  }

  ngOnInit() {
    this.sub = this.route.queryParams.subscribe(params => {
      this.userId = params['userId'];
      this.code = params['code'];// (+) converts string 'id' to a number

      // In a real app: dispatch action to load the details here.
    });
  }


  ResetPassword() {
    if (this.newPassword == this.confirmPassword) {
      this.showErrorMsg = false;
      this.userService.ResetPassword(this.userId, this.code, this.newPassword, this.email.toLowerCase()).subscribe(x => {
        this.passwordChanged = true;
      },
        error => {

        }
      );
    }
    else {
      this.showErrorMsg = true;
    }
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /Users/mowebdevice/Desktop/Web Project/angular-scrubup/src/app/reset-password/reset-password.component.ts